function formatFieldErrors(value: unknown): string {
  if (Array.isArray(value)) {
    return value.map(String).join(' ');
  }

  return String(value);
}

export function getApiErrorMessage(
  err: any,
  field?: string,
  fallback = 'Сталася помилка при збереженні даних.',
): string {
  const errorBody = err?.error;

  if (!errorBody) {
    return fallback;
  }

  if (typeof errorBody === 'string') {
    return errorBody;
  }

  if (errorBody.detail) {
    if (typeof errorBody.detail === 'string') {
      return errorBody.detail;
    }

    if (Array.isArray(errorBody.detail)) {
      return errorBody.detail.map(String).join(' ');
    }
  }

  if (field && errorBody[field]) {
    return formatFieldErrors(errorBody[field]);
  }

  const keys = Object.keys(errorBody);
  if (keys.length > 0) {
    return formatFieldErrors(errorBody[keys[0]]);
  }

  return fallback;
}
